"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_enterprise(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "df9707b7-8fe4-4ce5-9a08-e7d71dfa9c1f",
    x1: 53.81,
    y1: 99.34,
    x2: 121.31,
    y2: 166.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "enterprise-hi"), /*#__PURE__*/React.createElement("g", {
    id: "752fde25-8e15-4fe8-9657-d0e63ca46046",
    "data-name": "enterprise-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "acf7f835-5d8d-46fd-bd71-89af0ddba4d1",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c7d226c6-ee26-4d9e-b91a-b712a04a7cea",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8fce806f-61c9-43e5-850c-1ddfe5875687",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "206701bf-a855-4063-8693-a02cddb59481",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5bfa4d83-d601-4f42-9d5e-c17220476097",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "192c9930-6832-4cda-882f-feead915afcb",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "77825219-1f98-4201-a937-9db8e2259dce",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "961e5224-d9e9-4140-954d-97ec9c696e1d",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f9ad9d4c-3b9c-4cc8-af7b-265d0d87a317",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b1c08962-2f84-4c2f-aa4b-d898b509f620",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aad83e3e-14b8-48d9-bc7e-8bf728e77b2b",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7a1cb8e6-0f18-4dd3-8188-e42426871cc0",
    "data-name": "Edit_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f59bede8-b6ed-4d09-834d-d69fc651148e",
    "data-name": "Enterprise_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,20h64a8,8,0,0,1,8,8V172a0,0,0,0,1,0,0H56a0,0,0,0,1,0,0V28A8,8,0,0,1,64,20Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,20h64a8,8,0,0,1,8,8V172a0,0,0,0,1,0,0H56a0,0,0,0,1,0,0V28A8,8,0,0,1,64,20Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 83,
    width: 66,
    height: 12,
    rx: 2,
    ry: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 101,
    width: 66,
    height: 12,
    rx: 2,
    ry: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 119,
    width: 66,
    height: 12,
    rx: 2,
    ry: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 137,
    width: 66,
    height: 12,
    rx: 2,
    ry: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,83H65a2,2,0,0,0-2,2v2a2,2,0,0,1,2-2h62a2,2,0,0,1,2,2V85A2,2,0,0,0,127,83Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,101H65a2,2,0,0,0-2,2v2a2,2,0,0,1,2-2h62a2,2,0,0,1,2,2v-2A2,2,0,0,0,127,101Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,119H65a2,2,0,0,0-2,2v2a2,2,0,0,1,2-2h62a2,2,0,0,1,2,2v-2A2,2,0,0,0,127,119Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,137H65a2,2,0,0,0-2,2v2a2,2,0,0,1,2-2h62a2,2,0,0,1,2,2v-2A2,2,0,0,0,127,137Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 47,
    width: 66,
    height: 12,
    rx: 2,
    ry: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 65,
    width: 66,
    height: 12,
    rx: 2,
    ry: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,47H65a2,2,0,0,0-2,2v2a2,2,0,0,1,2-2h62a2,2,0,0,1,2,2V49A2,2,0,0,0,127,47Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 29,
    width: 66,
    height: 12,
    rx: 2,
    ry: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,29H65a2,2,0,0,0-2,2v2a2,2,0,0,1,2-2h62a2,2,0,0,1,2,2V31A2,2,0,0,0,127,29Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,65H65a2,2,0,0,0-2,2v2a2,2,0,0,1,2-2h62a2,2,0,0,1,2,2V67A2,2,0,0,0,127,65Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 154,
    width: 12,
    height: 18,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116 172.15 78.08 172.15 78.08 75.07 116.01 112.99 116 172.15",
    opacity: 0.2,
    fill: "url(#df9707b7-8fe4-4ce5-9a08-e7d71dfa9c1f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,72H72a8,8,0,0,1,8,8v92a0,0,0,0,1,0,0H24a0,0,0,0,1,0,0V80A8,8,0,0,1,32,72Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 83,
    width: 44,
    height: 12,
    rx: 2,
    ry: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 101,
    width: 44,
    height: 12,
    rx: 2,
    ry: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 120,
    width: 44,
    height: 11.77,
    rx: 2,
    ry: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 138,
    width: 44,
    height: 11.77,
    rx: 2,
    ry: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,83H32a2,2,0,0,0-2,2v2a2,2,0,0,1,2-2H72a2,2,0,0,1,2,2V85A2,2,0,0,0,72,83Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,101H32a2,2,0,0,0-2,2v2a2,2,0,0,1,2-2H72a2,2,0,0,1,2,2v-2A2,2,0,0,0,72,101Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,120H32a2,2,0,0,0-2,2v2a2,2,0,0,1,2-2H72a2,2,0,0,1,2,2v-2A2,2,0,0,0,72,120Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,138H32a2,2,0,0,0-2,2v2a2,2,0,0,1,2-2H72a2,2,0,0,1,2,2v-2A2,2,0,0,0,72,138Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 154,
    width: 12,
    height: 18,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,108h40a8,8,0,0,1,8,8v56a0,0,0,0,1,0,0H112a0,0,0,0,1,0,0V116A8,8,0,0,1,120,108Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 119,
    width: 44,
    height: 12,
    rx: 2,
    ry: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 137,
    width: 44,
    height: 12,
    rx: 2,
    ry: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,119H120a2,2,0,0,0-2,2v2a2,2,0,0,1,2-2h40a2,2,0,0,1,2,2v-2A2,2,0,0,0,160,119Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,137H120a2,2,0,0,0-2,2v2a2,2,0,0,1,2-2h40a2,2,0,0,1,2,2v-2A2,2,0,0,0,160,137Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 154,
    width: 12,
    height: 18,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56 170 24 170 24 172 56 172 136 172 168 172 168 170 136 170 56 170",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 23,
    width: 30,
    height: 4,
    rx: 2,
    ry: 2,
    fill: "#e60000"
  }))))))))))))))));
}

var _default = ic_enterprise;
exports.default = _default;